import react, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { FormGroup } from "reactstrap";
import { Form } from "reactstrap";
import { Input } from "reactstrap";
import { Container, Row, Col } from "reactstrap";
import LogoMain from "assets/img/Logo_AcquaMonitoring.svg";
import "./auth.css";
import { API_URL } from "../../views/composant/Config/apiConfig";

export default function ResetPassword() {
  const nav = useNavigate();

  const token = localStorage.getItem("token");

  //AXIOS CONFIGURATION
  let CONFIG_ = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  const [password, setPassword] = useState();
  const [code, setCode] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const confirmPasswordError = document.getElementById(
    "confirm-password-error"
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      confirmPasswordError.textContent =
        "Le mot de passe et la confirmation du mot de passe ne correspondent pas.";
      return;
    } else {
      confirmPasswordError.textContent = "";
    }

    axios
      .post(
        API_URL + "reset-password",
        {
          code,
          password,
        },
        CONFIG_
      )
      .then(function (response) {
        nav("/admin");
      })
      .catch(function (error) {});
  };

  return (
    <div className="height-login">
      <Row className="center-login">
        <Col className="background-login">
          <Form className="container-update-login" onSubmit={handleSubmit}>
            <img className=" logo-login" src={LogoMain} alt="logo-login"></img>
            <div className="label-passwordUp">
              Entrez le token de réinitialisation
            </div>
            <FormGroup>
              <Input
                className="input-login"
                type="text"
                placeholder=""
                name="psw"
                onChange={(e) => setCode(e.target.value)}
                required
              />
            </FormGroup>
            <div className="label-passwordUp">
              Entrez un nouveau mot de passe
            </div>
            <FormGroup>
              <Input
                className="input-login"
                type="password"
                placeholder="Mot de passe"
                name="psw"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </FormGroup>
            <FormGroup>
              <Input
                className="input-login"
                type="password"
                placeholder="Confirmation de mot de passe"
                name="psw"
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </FormGroup>
            <div id="confirm-password-error" className="confirm-error"></div>
            <Button className="" color="primary" type="submit">
              Changer le Mot de Passe
            </Button>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
